export {
    CUSTOM_MARKER_MIN_GOOGLE_ZOOM,
    CUSTOM_MARKER_TROLLEY_MIN_GOOGLE_ZOOM,
    CUSTOM_MARKER_MIN_FRONT_STYLE_LVZ,
    CUSTOM_MARKER_ICON_SIZE_SMALL_PX,
    CUSTOM_MARKER_ICON_SIZE_COMPACT_PX,
    CUSTOM_MARKER_ICON_SIZE_MID_PX,
    CUSTOM_MARKER_ICON_SIZE_LARGE_PX,
    googleZoomMeetsCustomMarkerMin,
    googleZoomMeetsCustomMarkerVisibility,
    getCustomMarkerMinGoogleZoom,
    isTrolleyCustomMarkerDescription,
    liveviewZoneFrontStyleLvzForGoogleZoom,
    LIVEVIEW_ZONE_ZOOM_THRESHOLDS,
    getCustomMarkerIconSizePx,
    getCustomMarkerIconAnchor,
} from './customMarkerZoom';

/** Fallback when the remote icon fails to load in the browser. */
export const CUSTOM_MARKER_FALLBACK_ICON_URL = 'images/Markers/cocomrkr.png';
